export default __webpack_public_path__ + "static/media/orderBackground.dbe7ad51.svg";